import { format, differenceInMinutes, isToday } from "date-fns";
import Vue from "vue";

Vue.directive("relativedate", {
  bind(el, binding) {
    const value = binding.value;
    const diffMinutes = differenceInMinutes(new Date(), new Date(value * 1000));
    let result = "";
    if (diffMinutes < 1) {
      result = "Just now";
    } else if (diffMinutes < 60) {
      result = `${diffMinutes} mins ago`;
    } else if (isToday(new Date(value * 1000))) {
      result = format(new Date(value * 1000), "h:mm a");
    } else {
      result = format(new Date(value * 1000), "MMM dd");
    }
    // eslint-disable-next-line
    el.innerHTML = result;
    // eslint-disable-next-line
    el.interval = setInterval(() => {
      // eslint-disable-next-line
      el.innerHTML = result;
    }, 1000);
  },

  unbind(el) {
    clearInterval(el.interval);
  }
});

Vue.filter("relativetime", value => {
  let result = "";
  if (isToday(new Date(value * 1000))) {
    result = format(new Date(value * 1000), "h:mm a");
  } else {
    result = format(new Date(value * 1000), "MMM dd");
  }
  return result;
});

Vue.filter("messageTime", value => {
  return format(new Date(value * 1000), "h:mm a");
});